import { Box } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

const heightDefault = 720
const heightLaptopL = 560

export const ItemContainer = styled(Box)`
  min-width: 300px;
  padding: 0;

  a {
    height: ${heightDefault}px;
  }

  ${({ theme }) => css`
    ${theme.below.laptopL`
      height: ${heightLaptopL}px;

      a {
        height: ${heightLaptopL}px;
      }
    `}

    ${theme.below.tabletS`
      height: 660px;
      a {
        height: ${heightDefault}px;
      }
    `}
  `}
`

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    padding: 0;

    ${theme.below.mobileXL`
      & > div > p {
        padding: 0 ${theme.newSpaces.xs}px;
      }
    `}
  `}
`
